import { Button, Chip, Dialog, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import Popup from "elements/Popup";
import { ApiRequest } from "GlobalFunctions";

export default function ReportViewer(props: any) {
  const { loading, setLoading, open, setOpen, data, reportName, getReport, exportParams, processed, label_type, product_name, subtitle } = props;
  const { enqueueSnackbar } = useSnackbar();

  /*=======================================
  EXPORT FUNCTIONS - SEPARATE FROM VIEW
  =======================================*/
  const exportReport = async (format: 'excel' | 'pdf') => {
    setLoading(true);
    
    await ApiRequest({
      url: "/reports/exportRoutesWebReport",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        ...exportParams, // Parámetros del formulario original (fecha, usuario, etc.)
        exportType: reportName,
        download: format,
        report_type: reportName
      },
      setResponse: (response: any) => {
        if (response.status === "success") {
          if (format === 'pdf') {
            window.open(response.pdfUrl, '_blank');
          } else if (format === 'excel') {
            window.open(response.fileUrl, '_blank');
          }
        } else {
          enqueueSnackbar(response.message || 'Error al exportar', { variant: 'error' });
        }
        setLoading(false);
      },
    });
  };


  /*=======================================
  SWITCH CASE VALUE TO GET TITLE
  =======================================*/
  
  const [title, setTitle] = useState('');
  useEffect(() => {
    switch (reportName) {
      case 'GetCountUnitInventory':
        setTitle('Conteo de inventario unidades');
        break;
      case 'GetCountUnitInventoryWarehouse':
        setTitle('Conteo de inventario x almacenes');
        break;
      case 'GetCountUsersUnit':
        setTitle('Conteo de inventario unidades x usuario');
        break;
      case 'GetCountUsersDifferences':
        setTitle('Diferencias');
        break;
      case 'GetPhysicalCountVersusInventory':
        setTitle('Inventario físico vs sistema');
        break;
      case 'GetMissingAndLeftoverCount':
        setTitle('Inventario faltante vs sobrante');
        break;
      case 'GetPrice':
        setTitle('Inventario faltante vs sobrante x valores');
        break;
      case 'GetStock':
        setTitle('Inventario físico vs stock');
        break;
      case 'GetSimilarCount':
        setTitle('Similares');
        break;
      case 'GetBarcodeHistory':
        setTitle('Historial de códigos de barras');
        break;
      /*=======================================
      DEBT
      =======================================*/
      case 'byAge':
        setTitle('Cartera por edades');
        break;
      case 'OverdueInvoices':
        setTitle('Cartera vencida');
        break;
      case 'byClient':
        setTitle('Cartera por cliente');
        break;
      case 'byPaymentMethod':
        setTitle('Recaudo por método de pago');
        break;
      case 'byUser':
        setTitle('Recaudo por usuario');
        break;
      case 'totalCompany':
        setTitle('Cartera total empresa');
        break;


      /*=======================================
      ORDERS
      =======================================*/
      case 'sales_byUser':
        setTitle('Ventas por usuario');
        break;
      
      
      // ORDERS (faltantes de OrdersReports)
      case 'orders_range':
        setTitle('Pedidos');
        break;
      case 'new_clients':
        setTitle('Nuevos Clientes');
        break;
      case 'updated_clients':
        setTitle('Clientes Actualizados');
        break;
      case 'orders':
        setTitle('Pedidos (móvil)');
        break;
      case 'ordersWithMessage':
        setTitle('Pedidos con mensaje');
        break;
      case 'ineffective_visits':
        setTitle('Visitas sin compra');
        break;
      case 'sales_by_product':
        setTitle('Ventas por producto');
        break;
      case 'sales_by_product_and_label':
        const labelText = label_type === 'new' ? 'Nuevos' : label_type === 'recommended' ? 'Recomendados' : label_type === 'promo' ? 'Promoción' : '';
        setTitle(`Ventas por etiqueta: ${labelText}`);
        break;
      case 'sales_by_supplier':
        setTitle('Ventas por proveedor');
        break;
      case 'clients_by_product':
        setTitle(product_name ? `Clientes por producto - ${product_name}` : 'Clientes por producto');
        break;
      case 'clients_by_supplier':
        setTitle('Clientes por proveedor');
        break;
      /*=======================================
      ROUTES
      =======================================*/
      case 'by_guide':
        setTitle('Relación guía');
        break;
      case 'by_user':
        setTitle('Relación por usuario');
        break;
      case 'returns':
        setTitle('Relación devoluciones');
        break;
      case 'partials':
        setTitle('Relación parciales');
        break;
      case 'loans':
        setTitle('Relación préstamos');
        break;
      case 'picking_summary':
        setTitle('Reporte Picking');
        break;
      case 'returns_novelties':
        setTitle('Reporte devoluciones y/o novedades');
        break;
      case 'assigned_assets':
        setTitle('Activos asignados');
        break;
      // New report
      case 'assets_novelties':
        setTitle('Novedades de activos');
        break;
      case 'route_changes':
        setTitle('Cambios de ruta');
        break;

      case 'orders_processed':
        const statusText = processed == 1 ? 'procesados' : 'sin procesar';
        setTitle(`Pedidos ${statusText}`);
        break;

      case 'budgets_report':
        setTitle('Presupuestos');
        break;

      case 'clients_without_coordinates':
        setTitle('Clientes sin coordenadas');
        break;

      case 'clients_by_company':
        setTitle('Clientes por empresa');
        break;

      case 'products_by_company':
        setTitle('Productos por empresa');
        break;

      /*=======================================
      ACCESOS
      =======================================*/
      case 'accesos':
        setTitle('Ingresos');
        break;

      default:
        setTitle('Reporte');
        break;
    }
  }, [reportName, processed, label_type, product_name]);
  


  return (
    <>
      <Popup 
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        fullWidth={true}
        maxWidth="xl"
        loading={loading}

      >
        <div className="DialogContainer" style={{ width: 'auto' }}>
          <div className="ModuleWrapper">
            <div className="boxContainerHeader">
              <div className="boxContainerTitle">
                <h2 className="h2_title">{title}</h2>
                {subtitle && <span className="h2_subtitle">{subtitle}</span>}
              </div>
            </div>

            <div className="content">
              {/* BUDGETS REPORT - flat table matching export */}
              {data && data.type === 'budgets' && data.table && data.table.rows && data.table.rows.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {data.table.headers.map((header: string) => (
                          <TableCell key={header} style={{ fontWeight: 'bold' }}>{header}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.table.rows.map((row: any, index: number) => {
                        const isGroupHeader = row['Comercial'] === 'TOTAL EMPRESA';
                        return (
                          <TableRow key={index} style={isGroupHeader ? { backgroundColor: '#e3f2fd' } : {}}>
                            {data.table.headers.map((header: string) => (
                              <TableCell
                                key={header}
                                style={isGroupHeader ? { fontWeight: 'bold' } : {}}
                              >
                                {row[header]}
                              </TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : data && data.headers && data.rows && data.rows.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {data.headers.map((header: string) => (
                          <TableCell key={header}>{header}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.rows.map((row: any, index: number) => (
                        <TableRow key={index}>
                          {data.headers.map((header: string) => (
                            <TableCell key={header}>{row[header]}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : data && data.tableHeaders && reportName === 'picking_summary' && (
                  Array.isArray(data.data) && data.data.length > 0
                ) ? (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {data.tableHeaders.map((header: string) => (
                          <TableCell key={header}>{header}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.data.map((row: any, index: number) => (
                        <TableRow key={index}>
                          {data.tableHeaders.map((header: string) => (
                            <TableCell key={header} style={header === 'Completado por' ? { whiteSpace: 'pre-line' } : {}}>
                              {row[header]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : data && data.tableHeaders && (reportName === 'returns' || reportName === 'partials' || reportName === 'loans') ? (
                // Table format for returns, partials, loans reports
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {data.tableHeaders.map((header: string) => (
                          <TableCell key={header}>{header}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* Use the direct data array from the API response */}
                      {(data.data && Array.isArray(data.data) ? data.data : 
                        Array.isArray(data) ? data.filter((item: any) => typeof item === 'object' && item !== null && !Array.isArray(item)) :
                        []
                      ).map((row: any, index: number) => (
                        <TableRow key={index}>
                          {data.tableHeaders.map((header: string) => (
                            <TableCell key={header}>{row[header] || ''}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : reportName === 'accesos' && data && data.tableHeaders && Array.isArray(data.data) && data.data.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {data.tableHeaders.map((header: string) => (
                          <TableCell key={header}>{header}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.data.map((row: any, index: number) => (
                        <TableRow key={index}>
                          {data.tableHeaders.map((header: string) => (
                            <TableCell key={header}>
                              {header === 'Imágenes entrada' && Array.isArray(row._images) && row._images.length > 0
                                ? row._images.map((url: string, imgIdx: number) => (
                                    <span key={imgIdx}>
                                      <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                                        Foto {imgIdx + 1}
                                      </a>
                                      {imgIdx < row._images.length - 1 && ' | '}
                                    </span>
                                  ))
                                : header === 'Imágenes salida' && Array.isArray(row._exit_images) && row._exit_images.length > 0
                                  ? row._exit_images.map((url: string, imgIdx: number) => (
                                      <span key={imgIdx}>
                                        <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                                          Foto {imgIdx + 1}
                                        </a>
                                        {imgIdx < row._exit_images.length - 1 && ' | '}
                                      </span>
                                    ))
                                  : row[header]
                              }
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : data && data.tableHeaders && (
                  (Array.isArray(data.data) && data.data.length > 0) || 
                  (Array.isArray(data) && data.length > 0 && typeof data[0] === 'object')
                ) ? (
                // Table format for other reports with tableHeaders
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {data.tableHeaders.map((header: string) => (
                          <TableCell key={header}>{header}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(data.data || data).map((row: any, index: number) => (
                        <TableRow key={index}>
                          {data.tableHeaders.map((header: string) => (
                            <TableCell key={header}>{row[header]}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : data && Array.isArray(data) && data.length > 0 && (reportName === 'by_guide' || reportName === 'by_user') ? (
                // Special format for routes reports
                <div style={{ padding: '20px' }}>
                  {data.map((guide: any, index: number) => (
                    <div key={index} style={{ marginBottom: '40px', border: '1px solid #ddd', borderRadius: '8px', padding: '20px' }}>
                      <div style={{ backgroundColor: '#f0f0f0', padding: '15px', marginBottom: '20px', borderRadius: '5px', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ margin: 0, color: '#333' }}>
                          Planilla #: {guide.guide_code} - Facturas acusadas: ${Number(guide.total_guide_value).toLocaleString()}
                        </Typography>
                        <Typography variant="body1" style={{ margin: '5px 0 0 0' }}>
                          Número de facturas acusadas: {guide.total_guide_orders}
                        </Typography>
                      </div>
                      
                      {reportName === 'by_user' && guide.users ? (
                        Object.values(guide.users).map((user: any, userIndex: number) => {
                          // Calcular total recaudado dinámicamente como en mobile
                          const payments = user.payments || {};
                          const deliveryStatus = user.delivery_status || {};
                          const creditData = user.credit_data || {};
                          const totalRecaudado = Object.values(payments).reduce((sum: number, amount: any) => sum + Number(amount), 0);
                          
                          return (
                            <div key={userIndex} style={{ marginBottom: '30px', borderLeft: '4px solid #007bff', paddingLeft: '15px' }}>
                              <Typography variant="h6" style={{ margin: '0 0 10px 0', color: '#007bff' }}>
                                {user.user_name}
                              </Typography>
                              <Typography variant="body2" style={{ margin: '5px 0' }}>
                                <strong>Pedidos:</strong> {user.total_orders}
                              </Typography>
                              <Typography variant="body2" style={{ margin: '5px 0' }}>
                                <strong>Valor:</strong> ${Number(user.total_guide_value).toLocaleString()}
                              </Typography>
                              
                              {Object.keys(payments).length > 0 && (
                                <div style={{ marginBottom: '15px' }}>
                                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>Recaudado (NO crédito):</Typography>
                                  {Object.entries(payments).map(([method, amount]: [string, any]) => (
                                    <Typography key={method} variant="body2">
                                      {method}: ${Number(amount).toLocaleString()}
                                    </Typography>
                                  ))}
                                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                    Total recaudado: ${totalRecaudado.toLocaleString()}
                                  </Typography>
                                </div>
                              )}
                              
                              {/* Formato de 3 columnas como en by_guide */}
                              <div style={{ marginTop: '20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                  {/* Columna 1 - Pendientes (Negro) - No aplica por usuario, se omite */}
                                  <div style={{ flex: 1, padding: '5px', borderRight: '1px solid #ccc' }}>
                                    <Typography variant="body2" style={{ color: '#666', fontWeight: 'bold', fontSize: '12px' }}>
                                      Datos por usuario:
                                    </Typography>
                                  </div>
                                  
                                  {/* Columna 2 - Verde y Naranja (Entregas y recibido) */}
                                  <div style={{ flex: 1, padding: '5px', borderRight: '1px solid #ccc' }}>
                                    <Typography variant="body2" style={{ color: '#2E7D2E', fontWeight: 'bold', fontSize: '12px', marginBottom: '8px' }}>
                                      Dinero Recibido entregas totales: ${Number(deliveryStatus.entregado?.value || 0).toLocaleString()} - {deliveryStatus.entregado?.count || 0} pedido{(deliveryStatus.entregado?.count || 0) !== 1 ? 's' : ''}
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '12px' }}>
                                      Dinero Recibido entregas parciales: ${Number(deliveryStatus.parcial?.value || 0).toLocaleString()} - {deliveryStatus.parcial?.count || 0} pedido{(deliveryStatus.parcial?.count || 0) !== 1 ? 's' : ''}
                                    </Typography>
                                    {creditData.entregas_totales_credito && (creditData.entregas_totales_credito.value > 0 || creditData.entregas_totales_credito.count > 0) && (
                                      <Typography variant="body2" style={{ color: '#2E7D2E', fontWeight: 'bold', fontSize: '12px', marginTop: '6px' }}>
                                        Entregas totales a crédito: ${Number(creditData.entregas_totales_credito.value || 0).toLocaleString()} - {creditData.entregas_totales_credito.count || 0} pedido{(creditData.entregas_totales_credito.count || 0) !== 1 ? 's' : ''}
                                      </Typography>
                                    )}
                                    {creditData.entregas_parciales_credito && (creditData.entregas_parciales_credito.value > 0 || creditData.entregas_parciales_credito.count > 0) && (
                                      <Typography variant="body2" style={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '12px', marginTop: '2px' }}>
                                        Entregas parciales a crédito: ${Number(creditData.entregas_parciales_credito.value || 0).toLocaleString()} - {creditData.entregas_parciales_credito.count || 0} pedido{(creditData.entregas_parciales_credito.count || 0) !== 1 ? 's' : ''}
                                      </Typography>
                                    )}
                                  </div>
                                  
                                  {/* Columna 3 - Rojo (Devoluciones) */}
                                  <div style={{ flex: 1, padding: '5px' }}>
                                    <Typography variant="body2" style={{ color: '#CC0000', fontWeight: 'bold', fontSize: '12px', marginBottom: '8px' }}>
                                      Devoluciones totales: ${Number(deliveryStatus.devuelto?.value || 0).toLocaleString()} - {deliveryStatus.devuelto?.count || 0} pedido{(deliveryStatus.devuelto?.count || 0) !== 1 ? 's' : ''}
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#CC0000', fontWeight: 'bold', fontSize: '12px' }}>
                                      Devoluciones entregas parciales: ${Number(creditData.devoluciones_entregas_parciales?.value || 0).toLocaleString()} - {creditData.devoluciones_entregas_parciales?.count || 0} pedido{(creditData.devoluciones_entregas_parciales?.count || 0) !== 1 ? 's' : ''}
                                    </Typography>
                                    {creditData.devoluciones_entregas_parciales_credito && (creditData.devoluciones_entregas_parciales_credito.value > 0 || creditData.devoluciones_entregas_parciales_credito.count > 0) && (
                                      <Typography variant="body2" style={{ color: '#CC0000', fontWeight: 'bold', fontSize: '12px', marginTop: '2px' }}>
                                        Devolución entregas parciales a crédito: ${Number(creditData.devoluciones_entregas_parciales_credito.value || 0).toLocaleString()} - {creditData.devoluciones_entregas_parciales_credito.count || 0} pedido{(creditData.devoluciones_entregas_parciales_credito.count || 0) !== 1 ? 's' : ''}
                                      </Typography>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : reportName === 'by_guide' && (
                        <div style={{ marginBottom: '30px', borderLeft: '4px solid #28a745', paddingLeft: '15px' }}>
                          {guide.payments && Object.keys(guide.payments).length > 0 && (
                            <div style={{ marginBottom: '15px' }}>
                              <Typography variant="body2" style={{ fontWeight: 'bold' }}>Recaudado:</Typography>
                              {Object.entries(guide.payments).map(([method, amount]: [string, any]) => (
                                <Typography key={method} variant="body2">
                                  {method}: ${Number(amount).toLocaleString()}
                                </Typography>
                              ))}
                              <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                Total recaudado: ${Number(guide.total_recaudado || 0).toLocaleString()}
                              </Typography>
                            </div>
                          )}
                          
                          {guide.cash_payments && (guide.cash_payments.cash?.length > 0 || guide.cash_payments.expenses?.length > 0) && (
                            <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '5px' }}>
                              {guide.cash_payments.cash?.length > 0 && (
                                <div style={{ marginBottom: '10px' }}>
                                  <Typography variant="body2" style={{ fontWeight: 'bold', color: '#1565C0' }}>Detalle Efectivo:</Typography>
                                  {guide.cash_payments.cash.map((item: any, idx: number) => {
                                    const denominations = item.denominations
                                      ? (typeof item.denominations === 'string' ? JSON.parse(item.denominations) : item.denominations)
                                      : null;
                                    return (
                                      <div key={idx} style={{ marginBottom: denominations ? 6 : 2 }}>
                                        <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                          ${Number(item.amount).toLocaleString()}{item.notes ? ` (${item.notes})` : ''}
                                        </Typography>
                                        {denominations && Object.keys(denominations).length > 0 && (
                                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 3 }}>
                                            {Object.entries(denominations)
                                              .sort((a: any, b: any) => Number(b[0]) - Number(a[0]))
                                              .map(([denom, count]: [string, any]) => {
                                                const isMoneda = [50, 100, 200, 500, 1000].includes(Number(denom));
                                                return (
                                                  <Chip
                                                    key={denom}
                                                    size="small"
                                                    label={`${isMoneda ? 'Moneda' : 'Billete'} $${Number(denom).toLocaleString()} x${count} = $${(Number(denom) * Number(count)).toLocaleString()}`}
                                                    sx={{
                                                      backgroundColor: isMoneda ? '#fff3e0' : '#e3f2fd',
                                                      border: `1px solid ${isMoneda ? '#ffb74d' : '#90caf9'}`,
                                                      fontSize: '11px',
                                                      height: '24px',
                                                    }}
                                                  />
                                                );
                                              })
                                            }
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                  <Typography variant="body2" style={{ fontWeight: 'bold', marginTop: 6, borderTop: '1px solid #e0e0e0', paddingTop: 4 }}>
                                    Total efectivo: ${guide.cash_payments.cash.reduce((s: number, i: any) => s + Number(i.amount), 0).toLocaleString()}
                                  </Typography>
                                </div>
                              )}
                              {guide.cash_payments.expenses?.length > 0 && (
                                <div>
                                  <Typography variant="body2" style={{ fontWeight: 'bold', color: '#C62828' }}>Gastos:</Typography>
                                  {guide.cash_payments.expenses.map((item: any, idx: number) => (
                                    <Typography key={idx} variant="body2">
                                      {item.concept}: ${Number(item.amount).toLocaleString()}{item.notes ? ` (${item.notes})` : ''}
                                    </Typography>
                                  ))}
                                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                    Total gastos: ${guide.cash_payments.expenses.reduce((s: number, i: any) => s + Number(i.amount), 0).toLocaleString()}
                                  </Typography>
                                </div>
                              )}
                            </div>
                          )}
                          
                          {guide.new_format ? (
                            // Nuevo formato con 3 columnas para cada planilla
                            <div style={{ marginTop: '20px' }}>

                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                {/* Columna 1 - Negro */}
                                <div style={{ flex: 1, padding: '5px', borderRight: '1px solid #ccc' }}>
                                  <Typography variant="body2" style={{ color: '#000', fontWeight: 'bold', fontSize: '12px' }}>
                                    Pendiente por Entregar: ${Number(guide.new_format?.pendiente_entregar?.valor || 0).toLocaleString()} - {guide.new_format?.pendiente_entregar?.pedidos || 0} pedidos
                                  </Typography>
                                </div>
                                
                                {/* Columna 2 - Verde y Naranja */}
                                <div style={{ flex: 1, padding: '5px', borderRight: '1px solid #ccc' }}>
                                  <Typography variant="body2" style={{ color: '#2E7D2E', fontWeight: 'bold', fontSize: '12px', marginBottom: '8px' }}>
                                    Dinero Recibido entregas totales: ${Number(guide.new_format?.dinero_recibido_entregas_totales?.valor || 0).toLocaleString()} - {guide.new_format?.dinero_recibido_entregas_totales?.pedidos || 0} pedido{(guide.new_format?.dinero_recibido_entregas_totales?.pedidos || 0) !== 1 ? 's' : ''}
                                  </Typography>
                                  <Typography variant="body2" style={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '12px' }}>
                                    Dinero Recibido entregas parciales: ${Number(guide.new_format?.dinero_recibido_entregas_parciales?.valor || 0).toLocaleString()} - {guide.new_format?.dinero_recibido_entregas_parciales?.pedidos || 0} pedido{(guide.new_format?.dinero_recibido_entregas_parciales?.pedidos || 0) !== 1 ? 's' : ''}
                                  </Typography>
                                  {guide.new_format?.entregas_totales_credito && (
                                    <Typography variant="body2" style={{ color: '#2E7D2E', fontWeight: 'bold', fontSize: '12px', marginTop: '6px' }}>
                                      Entregas totales a crédito: ${Number(guide.new_format?.entregas_totales_credito?.valor || 0).toLocaleString()} - {guide.new_format?.entregas_totales_credito?.pedidos || 0} pedido{(guide.new_format?.entregas_totales_credito?.pedidos || 0) !== 1 ? 's' : ''}
                                    </Typography>
                                  )}
                                  {guide.new_format?.entregas_parciales_credito && (
                                    <Typography variant="body2" style={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '12px', marginTop: '2px' }}>
                                      Entregas parciales a crédito: ${Number(guide.new_format?.entregas_parciales_credito?.valor || 0).toLocaleString()} - {guide.new_format?.entregas_parciales_credito?.pedidos || 0} pedido{(guide.new_format?.entregas_parciales_credito?.pedidos || 0) !== 1 ? 's' : ''}
                                    </Typography>
                                  )}
                                </div>
                                
                                {/* Columna 3 - Rojo */}
                                <div style={{ flex: 1, padding: '5px' }}>
                                  <Typography variant="body2" style={{ color: '#CC0000', fontWeight: 'bold', fontSize: '12px', marginBottom: '8px' }}>
                                    Devoluciones totales: ${Number(guide.new_format?.devoluciones_totales?.valor || 0).toLocaleString()} - {guide.new_format?.devoluciones_totales?.pedidos || 0} pedido{(guide.new_format?.devoluciones_totales?.pedidos || 0) !== 1 ? 's' : ''}
                                  </Typography>
                                  <Typography variant="body2" style={{ color: '#CC0000', fontWeight: 'bold', fontSize: '12px' }}>
                                    Devoluciones entregas parciales: ${Number(guide.new_format?.devoluciones_entregas_parciales?.valor || 0).toLocaleString()} - {guide.new_format?.devoluciones_entregas_parciales?.pedidos || 0} pedido{(guide.new_format?.devoluciones_entregas_parciales?.pedidos || 0) !== 1 ? 's' : ''}
                                  </Typography>
                                  {guide.new_format?.devoluciones_entregas_parciales_credito && (
                                    <Typography variant="body2" style={{ color: '#CC0000', fontWeight: 'bold', fontSize: '12px', marginTop: '2px' }}>
                                      Devolución entregas parciales a crédito: ${Number(guide.new_format?.devoluciones_entregas_parciales_credito?.valor || 0).toLocaleString()} - {guide.new_format?.devoluciones_entregas_parciales_credito?.pedidos || 0} pedido{(guide.new_format?.devoluciones_entregas_parciales_credito?.pedidos || 0) !== 1 ? 's' : ''}
                                    </Typography>
                                  )}
                                </div>
                              </div>
                              
                              {/* Cuadre de planilla centrado por planilla (oculto) */}
                              
                              {/* Título de Novedades de la Entrega */}
                              <div style={{ textAlign: 'center', marginTop: '20px', borderTop: '2px solid #007bff', paddingTop: '15px' }}>
                                <Typography variant="h6" style={{ color: '#007bff', fontWeight: 'bold', fontSize: '16px' }}>
                                  NOVEDADES DE LA ENTREGA
                                </Typography>
                              </div>
                              
                              {/* Tabla de novedades */}
                              <div style={{ marginTop: '15px' }}>
                                <TableContainer component={Paper} style={{ marginTop: '10px' }}>
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Número de guía</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Número de factura</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Nit o CC</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Nombre o Razón social</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Estado Entrega</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Concepto devolucion</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Devueltos</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Préstamos</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Forma de pago</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Mensaje</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Imagenes</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {guide.novelties && guide.novelties.length > 0 ? (
                                        guide.novelties.map((novelty: any, noveltyIndex: number) => (
                                          <TableRow key={noveltyIndex}>
                                            <TableCell>{novelty.guide_code}</TableCell>
                                            <TableCell>{novelty.facture_code}</TableCell>
                                            <TableCell>{novelty.nit_cc}</TableCell>
                                            <TableCell>{novelty.client_name}</TableCell>
                                            <TableCell>
                                              <span style={{
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                color: novelty.estado_entrega === 'Entrega Total' ? '#2e7d32' : novelty.estado_entrega === 'Entrega Parcial' ? '#e65100' : novelty.estado_entrega === 'Devolución' ? '#c62828' : '#666'
                                              }}>
                                                {novelty.estado_entrega}
                                              </span>
                                            </TableCell>
                                            <TableCell>{novelty.concepto_devolucion}</TableCell>
                                            <TableCell>{novelty.devueltos}</TableCell>
                                            <TableCell>{novelty.prestamos}</TableCell>
                                            <TableCell>{novelty.payment_method || '-'}</TableCell>
                                            <TableCell>{novelty.message}</TableCell>
                                            <TableCell>
                                              {novelty.image_urls && novelty.image_urls.length > 0 ? (
                                                novelty.image_urls.map((url: string, imgIdx: number) => (
                                                  <span key={imgIdx}>
                                                    <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                                                      Foto {imgIdx + 1}
                                                    </a>
                                                    {imgIdx < novelty.image_urls.length - 1 && ' | '}
                                                  </span>
                                                ))
                                              ) : (
                                                'Sin imagen'
                                              )}
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      ) : (
                                        <TableRow>
                                          <TableCell colSpan={11} style={{ textAlign: 'center', color: '#666', fontStyle: 'italic' }}>
                                            No hay novedades registradas para esta planilla
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            </div>
                          ) : guide.delivery_status && (
                            // Formato antiguo para retrocompatibilidad
                            <div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                                <Typography variant="body2" style={{ color: '#2E7D2E', fontWeight: 'bold' }}>
                                  Valor entregado: ${Number(guide.delivery_status?.entregado?.value || 0).toLocaleString()} - {guide.delivery_status?.entregado?.count || 0} pedidos
                                </Typography>
                                <Typography variant="body2" style={{ color: '#CC0000', fontWeight: 'bold' }}>
                                  Devolución total: ${Number(guide.delivery_status?.devolucion?.value || 0).toLocaleString()} - {guide.delivery_status?.devolucion?.count || 0} pedidos
                                </Typography>
                                <Typography variant="body2" style={{ color: '#FF8C00', fontWeight: 'bold' }}>
                                  Entrega parcial: ${Number(guide.delivery_status?.entrega_parcial?.value || 0).toLocaleString()} - {guide.delivery_status?.entrega_parcial?.count || 0} pedidos
                                </Typography>
                              </div>
                              
                              {/* Título de Novedades de la Entrega para formato antiguo */}
                              <div style={{ textAlign: 'center', marginTop: '20px', borderTop: '2px solid #007bff', paddingTop: '15px' }}>
                                <Typography variant="h6" style={{ color: '#007bff', fontWeight: 'bold', fontSize: '16px' }}>
                                  NOVEDADES DE LA ENTREGA
                                </Typography>
                              </div>
                              
                              {/* Tabla de novedades para formato antiguo */}
                              <div style={{ marginTop: '15px' }}>
                                <TableContainer component={Paper} style={{ marginTop: '10px' }}>
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Número de guía</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Número de factura</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Nit o CC</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Nombre o Razón social</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Estado Entrega</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Concepto devolucion</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Devueltos</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Préstamos</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Mensaje</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Imagenes</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {guide.novelties && guide.novelties.length > 0 ? (
                                        guide.novelties.map((novelty: any, noveltyIndex: number) => (
                                          <TableRow key={noveltyIndex}>
                                            <TableCell>{novelty.guide_code}</TableCell>
                                            <TableCell>{novelty.facture_code}</TableCell>
                                            <TableCell>{novelty.nit_cc}</TableCell>
                                            <TableCell>{novelty.client_name}</TableCell>
                                            <TableCell>
                                              <span style={{
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                color: novelty.estado_entrega === 'Entrega Total' ? '#2e7d32' : novelty.estado_entrega === 'Entrega Parcial' ? '#e65100' : novelty.estado_entrega === 'Devolución' ? '#c62828' : '#666'
                                              }}>
                                                {novelty.estado_entrega}
                                              </span>
                                            </TableCell>
                                            <TableCell>{novelty.concepto_devolucion}</TableCell>
                                            <TableCell>{novelty.devueltos}</TableCell>
                                            <TableCell>{novelty.prestamos}</TableCell>
                                            <TableCell>{novelty.message}</TableCell>
                                            <TableCell>
                                              {novelty.image_urls && novelty.image_urls.length > 0 ? (
                                                novelty.image_urls.map((url: string, imgIdx: number) => (
                                                  <span key={imgIdx}>
                                                    <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                                                      Foto {imgIdx + 1}
                                                    </a>
                                                    {imgIdx < novelty.image_urls.length - 1 && ' | '}
                                                  </span>
                                                ))
                                              ) : (
                                                'Sin imagen'
                                              )}
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      ) : (
                                        <TableRow>
                                          <TableCell colSpan={10} style={{ textAlign: 'center', color: '#666', fontStyle: 'italic' }}>
                                            No hay novedades registradas para esta planilla
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                  
                  {/* Eliminamos el resumen global ya que ahora tenemos uno para cada planilla */}
                </div>
              ) : (
                <Typography variant="h6" align="center" style={{ padding: '20px' }}>
                  No hay datos disponibles para mostrar.
                </Typography>
              )}
            </div>
          </div>
        </div>

        <div className="dialogButtons" style={{ display: 'flex', justifyContent: 'space-between', padding: '16px' }}>
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            className="button_2"
          >
            Cerrar
          </Button>

          <Button onClick={() => getReport('excel')} variant="contained" className="button_1">Descargar Excel</Button>
          <Button onClick={() => getReport('pdf')} variant="contained" className="button_1">Descargar PDF</Button>
        </div>
      </Popup>
    </>
  );
}
